import { ca } from '@cian/analytics';
import { IAgentSchema, IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { getProduct } from '../../utils/tracking/getProduct';

interface ITrackBannerParams {
  offer: IOfferSchema;
  agent: IAgentSchema | null;
}
export interface IUserEBC {
  userId?: number;
  isAuthorized: boolean;
  abGroup: number;
}

export interface IPageEBC {
  breadCrumbs: string[];
  offerType: 'offer';
  offerID: number;
  pageType: 'Card';
  siteType: 'desktop';
}

export function trackClickOnBanner() {
  ca('eventSite', {
    action: 'click',
    category: 'card',
    label: 'new_ad_banner',
    name: 'oldevent',
  });
}

export function trackScrollOnBanner({ offer, agent }: ITrackBannerParams) {
  const product = getProduct(offer, agent);

  ca('eventSite', {
    action: 'show',
    category: 'card',
    label: 'new_ad_banner',
    name: 'soprevent',
    products: [product],
  });
}
